type NavigateHandler = (path: string) => void | Promise<void>

let navigateHandler: NavigateHandler | null = null

export const setNavigateToPathHandler = (handler: NavigateHandler): void => {
	navigateHandler = handler
}

export const clearNavigateToPathHandler = (): void => {
	navigateHandler = null
}

export const navigateToPath = (path: string): void => {
	if (navigateHandler) {
		void navigateHandler(path)
		return
	}

	globalThis.location.href = path
}
